/**
 * Phase N — Placeholder monogram used in place of a real founder headshot
 * until the founder provides one. Same serif-small-caps + brass rule treatment
 * as the ILC logo mark.
 *
 * TODO: swap monogram for real founder headshot when provided.
 */
export default function MonogramMark({ initials = "TA", size = "lg", subtitle = "Founder & CEO" }) {
  const sizes = {
    sm: { box: "w-20 h-20", txt: "text-2xl" },
    md: { box: "w-28 h-28", txt: "text-3xl" },
    lg: { box: "w-40 h-40", txt: "text-5xl" },
  }[size];
  return (
    <div className="inline-flex flex-col items-center" data-testid={`monogram-${initials.toLowerCase()}`}>
      <div className={`${sizes.box} bg-ivy border border-brass flex items-center justify-center`}>
        <span className={`font-serif ${sizes.txt} text-brass tracking-[0.15em]`}>{initials}</span>
      </div>
      <div className="mt-2 h-px w-full bg-brass" />
      <div className="mt-1 text-[9px] uppercase tracking-[0.28em] text-brass">{subtitle}</div>
    </div>
  );
}
